import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import checkProduct from '../views/checkProduct/index.vue'
import goodsDetailList from '../views/scanQrCodes/goodsDetailList.vue'
import logisticsMapNew from '../views/webview/logisticsMapNew.vue'

Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            name: 'HelloWorld',
            component: HelloWorld
        }, {
            path: '/checkProduct',
            name: 'checkProduct',
            component: checkProduct
        },
        {
            path: '/goodsDetailList',
            name: 'goodsDetailList',
            component: goodsDetailList
        },
        {
            path: '/logisticsMapNew',
            name: 'logisticsMapNew',
            component: logisticsMapNew
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js